
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/set-101/traits",
      function () {
        return require("private-next-pages/info/set-101/traits/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/set-101/traits"])
      });
    }
  